import { List } from 'immutable';
import { isCashinOfferVisible } from './subs';

export const filterTicketList = (ticketIds, tickets): List<Map<string, any>> =>
    List(
        ticketIds
            .map(ticketId => tickets?.get(ticketId))
            .filter(Boolean)
            .filter(cashinOffer => isCashinOfferVisible(cashinOffer.get('status')))
    );

/**
 * Sort cashin offers by stake (desc), if stakes are equal, then sort by submit date (asc)
 */
export const sortCashinOffersByStake = (filteredTicketsList: List<Map<string, any>>) =>
    filteredTicketsList?.sort((firstTicket, secondTicket) => {
        if (firstTicket.get('stake') === secondTicket.get('stake'))
            return compareSubmitDates(firstTicket.get('submitDate'), secondTicket.get('submitDate'));
        return secondTicket.get('stake') - firstTicket.get('stake');
    });

const compareSubmitDates = (date1: string, date2: string) => Date.parse(date1) - Date.parse(date2);
